import { render } from "./DeputyForm.vue?vue&type=template&id=2e3b18d0&scoped=true"
import script from "./DeputyForm.vue?vue&type=script&lang=js"
export * from "./DeputyForm.vue?vue&type=script&lang=js"

import "./DeputyForm.vue?vue&type=style&index=0&id=2e3b18d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e3b18d0"]])

export default __exports__